export default __webpack_public_path__ + "static/media/customer_uncontracted_on.b588f4c2.svg";